export default __webpack_public_path__ + "static/media/wishlist-filled.33403302.svg";